module.exports = __webpack_public_path__ + "media/images/map/min-65993c10d76c5b9460be8d270fdc6353.svg";